import React from 'react';
import LazyPageLoader from '../../../cmp/LazyPageLoader';
import {useLocation, useNavigate, useParams} from 'react-router-dom';

const Page = React.lazy(()=>import('./DisplayContract'))

export default function LazyContractPage(props){
    const params = useParams()
    const navigate = useNavigate();
    const location = useLocation()
    return <React.Suspense fallback={<LazyPageLoader />}>
        <Page contract_id={params.contract_id}
              navigate={navigate}
              location={location}
        />
    </React.Suspense>
}
